import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on route (pathname) change.
 * SKIPS when the URL contains a #hash, so in-page anchors
 * (e.g. /about#ever-ll) still scroll to their target.
 * Mounted once inside <BrowserRouter> in App.js.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser/anchor handle in-page targets
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
